import React from "react";

import clsx from "clsx";

interface Props {
  onClick(): void;
}

export const ClearTextButton = ({ onClick }: Props) => (
  <button
    className={clsx(
      "flex shrink-0 items-center justify-center w-6 h-6 rounded text-primary",
      "hover:text-mars+0 hover:bg-mars-2 mr-1",
    )}
    onClick={onClick}
  >
    <i className="fa-regular fa-sharp fa-circle-xmark text-[0.8rem] mt-0.5"></i>
  </button>
);
